import { render, staticRenderFns } from "./Slider.vue?vue&type=template&id=5e584992&scoped=true"
import script from "./Slider.vue?vue&type=script&lang=js"
export * from "./Slider.vue?vue&type=script&lang=js"
import style0 from "./Slider.vue?vue&type=style&index=0&id=5e584992&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e584992",
  null
  
)

export default component.exports